package org.example.project.enginechat

import androidx.compose.runtime.*
import org.w3c.dom.HTMLDivElement
import org.example.project.utils.All
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

private fun chatLocalDate(block: All): Pair<String, String> {
    val raw = block.timestamp.ifBlank { block.datum }.trim()
    if (raw.isBlank()) return "" to ""
    val normalized = if (raw.endsWith(" UTC")) raw.removeSuffix(" UTC").replace(' ', 'T') + "Z" else raw
    val date = kotlin.js.Date(normalized)
    if (date.getTime().isNaN()) return "" to ""
    return (date.asDynamic().toLocaleDateString("de-DE") as String) to
        (date.asDynamic().toLocaleTimeString("de-DE", js("({hour:'2-digit',minute:'2-digit'})")) as String)
}

/** Shared message transcript used by the Lumatica chat and external read-only conversations. */
@Composable
fun ChatMessageList(messages: List<All>, ownMessage: (All) -> Boolean, authorLabel: (All) -> String, scrollable: Boolean = false) {
    var container by remember { mutableStateOf<HTMLDivElement?>(null) }
    LaunchedEffect(messages.lastOrNull()?.id, container) { if (scrollable) container?.let { it.scrollTop = it.scrollHeight.toDouble() } }
    Div({
        ref { container = it; onDispose { container = null } }
        style {
            display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(6.px); padding(12.px); minWidth(0.px); boxSizing("border-box")
            if (scrollable) { height(100.percent); minHeight(0.px); overflowY("auto") }
        }
    }) {
        var previousDay = ""
        var previousAuthor = ""
        messages.forEach { message ->
            val (day, time) = chatLocalDate(message)
            val newDay = day.isNotBlank() && day != previousDay
            if (newDay) Div({ style { textAlign("center"); padding(12.px, 0.px); color(Color("rgba(255,255,255,.65)")); fontSize(12.px) } }) { Text(day) }
            val own = ownMessage(message)
            val author = if (own) "" else authorLabel(message)
            key(message.id) {
                ChatBubble(message, own, if (newDay || author != previousAuthor) author else "", time)
            }
            previousDay = day
            previousAuthor = author
        }
    }
}
